export default function ($t) {
  return [
    {
      label: $t("date"),
      value: "createdAt",
    },
    {
      label: $t("agency"),
      value: "agencyId",
    },
    {
      label: $t("area"),
      value: "area",
    },
    {
      label: $t("city"),
      value: "city",
    },
    {
      label: $t("adjustmentOutletCode"),
      value: "outletCode",
    },
    {
      label: $t("addressProgramOrderExternalCode"),
      value: "externalCode",
    },
    {
      label: $t("kae"),
      value: "kaeValue",
    },
    {
      label: $t("kAS"),
      value: "kasValue",
    },
    {
      label: $t("addressProgramOrderRSMValue"),
      value: "rsmValue",
    },
  ];
}

